import { SubscriptionPlans } from "@/components/subscription/SubscriptionPlans";
import { useAuth } from "@/contexts/AuthContext";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";

export default function Pricing() {
  const { user } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    document.title = "Pricing - iSPAI";
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Navbar />
      <div className="container mx-auto px-4 py-16">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold mb-4">Choose Your Plan</h1>
          <p className="text-xl text-muted-foreground max-w-2xl mx-auto">
            Unlock the full potential of collaborative knowledge creation with Owned Gibs, 
            premium features, and access to the iSPAI ecosystem.
          </p>
        </div>

        {!user && (
          <div className="text-center mb-8">
            <p className="text-muted-foreground mb-4">
              Please log in to subscribe to a plan
            </p>
            <Button onClick={() => navigate("/auth")}>
              Log In to Subscribe
            </Button>
          </div>
        )}

        <SubscriptionPlans />

        <div className="mt-16 text-center">
          <h2 className="text-2xl font-semibold mb-4">Frequently Asked Questions</h2>
          <div className="max-w-2xl mx-auto space-y-6 text-left">
            <div>
              <h3 className="font-medium mb-2">What are Owned Gibs?</h3>
              <p className="text-muted-foreground text-sm">
                Owned Gibs are platform credits granted with your subscription. Use them for tipping creators, 
                unlocking premium content, and participating in bounties. They roll over month-to-month but are 
                forfeited if you cancel your subscription.
              </p>
            </div>
            <div>
              <h3 className="font-medium mb-2">Can I change plans later?</h3>
              <p className="text-muted-foreground text-sm">
                Yes! You can upgrade or downgrade your plan at any time. Changes take effect at your next billing cycle.
              </p>
            </div>
            <div>
              <h3 className="font-medium mb-2">What happens if I cancel?</h3>
              <p className="text-muted-foreground text-sm">
                You'll retain access until the end of your billing period. Any unused Owned Gibs will be forfeited, 
                but Earned Gibs remain in your account and can still be withdrawn.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
